import { C } from "./const";
import SectionBadge from "./IntroSectionBadge";
import SectionTitle from "./IntroSectionTitle";

const IntroAbout = () => {
    return (
        <section id="about" style={{ background: C.white, padding: "80px 24px" }}>
            <div
                className="grid-2"
                style={{
                    maxWidth: 1200,
                    margin: "0 auto",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 60,
                    alignItems: "center",
                }}
            >
                {/* Text side */}
                <div>
                    <SectionBadge text="درباره ما" />
                    <SectionTitle>چرا نمایندگی ما را انتخاب کنید؟</SectionTitle>
                    <p style={{ color: C.gray, fontSize: 16, lineHeight: 1.9, marginBottom: 32 }}>
                        ما متعهد به ارائه بهترین
                        خدمات و مشاوره تخصصی هستیم. تیم متخصص ما همواره آماده پاسخگویی
                        به سوالات شما است.
                    </p>

                    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                        {[
                            {
                                icon: "✅",
                                title: "مشاوره تخصصی رایگان",
                                desc: "کارشناسان ما بدون هیچ هزینه‌ای راهنمایی می‌کنند",
                            },
                            {
                                icon: "⚡",
                                title: "پردازش سریع خسارت",
                                desc: "تسویه خسارت در کمترین زمان ممکن",
                            },
                            {
                                icon: "🔒",
                                title: "اعتماد و شفافیت کامل",
                                desc: "ارائه اطلاعات کامل و شفاف بدون هیچ هزینه پنهانی",
                            },
                            {
                                icon: "📱",
                                title: "پشتیبانی ۲۴ ساعته",
                                desc: "در هر ساعت از شبانه‌روز در کنار شما هستیم",
                            },
                        ].map((item) => (
                            <div
                                key={item.title}
                                style={{
                                    display: "flex",
                                    gap: 14,
                                    alignItems: "flex-start",
                                    padding: "14px 16px",
                                    background: C.neutralLight,
                                    borderRadius: 12,
                                    border: `1px solid ${C.border}`,
                                }}
                            >
                                <span style={{ fontSize: 22, flexShrink: 0, marginTop: 1 }}>{item.icon}</span>
                                <div>
                                    <div style={{ fontWeight: 700, color: C.primaryDark, fontSize: 14, marginBottom: 3 }}>
                                        {item.title}
                                    </div>
                                    <div style={{ color: C.gray, fontSize: 13, lineHeight: 1.6 }}>
                                        {item.desc}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Card side */}
                <div
                    style={{
                        background: `linear-gradient(145deg, ${C.primaryDark}, ${C.primary})`,
                        borderRadius: 24,
                        padding: 44,
                        color: C.white,
                        textAlign: "center",
                    }}
                >
                    <div style={{ fontSize: 64, marginBottom: 20 }}>🏆</div>
                    <h3 style={{ fontSize: 22, fontWeight: 800, color: C.accent, marginBottom: 12 }}>
                        نمایندگی پارسیان
                    </h3>
                    <p style={{ fontSize: 14, lineHeight: 1.8, opacity: 0.88, marginBottom: 30 }}>
                        دارنده گواهینامه نمایندگی درجه یک از بیمه مرکزی ایران 
                    </p>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 12,
                        }}
                    >
                        {[
                            { num: "۱۵۰+", label: "نوع پوشش" },
                            { num: "۱۰۰٪", label: "قانونی" },
                            { num: "۲۴h", label: "پشتیبانی" },
                            { num: "A+", label: "رتبه اعتباری" },
                        ].map((item) => (
                            <div
                                key={item.label}
                                style={{
                                    background: "rgba(255,255,255,.1)",
                                    borderRadius: 12,
                                    padding: "16px 8px",
                                }}
                            >
                                <div style={{ fontSize: 22, fontWeight: 900, color: C.accent, marginBottom: 4 }}>
                                    {item.num}
                                </div>
                                <div style={{ fontSize: 12, opacity: 0.8 }}>{item.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}







export default IntroAbout;